exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wl-m-select[data-v-6fde5dd0] {\n  width: 100%;\n}\n.wl-overflow-tooltip[data-v-6fde5dd0] {\n  overflow: hidden;\n  display: inline-block;\n  width: 100%;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}", ""]);

// exports
